import secureStorage from "./encrypt";
import _ from "lodash";
// import ls from "local-storage";
export const TENANTS = {
	OTO: "oto-in",
	TRIV: "triv-id",
	FAV: "fav-id",
	EMP: "emp-id",
	PH: "ph"
}
//export const TENANT = ls.get("tenant") || TENANTS.OTO;
let tenant = process.env.REACT_APP_TENANT || TENANTS.OTO;

const OTO_URL = process.env.REACT_APP_OTO_URL || "";
const FAV_URL = process.env.REACT_APP_FAV_URL || "";
const EMP_URL = process.env.REACT_APP_EMP_URL || "";
const TRI_URL = process.env.REACT_APP_TRI_URL || "";
const PH_URL = process.env.REACT_APP_PH_URL || "";

const domain = window.location.hostname;

// OTO group
if (OTO_URL.includes(domain)) {
	tenant = TENANTS.OTO;
}
// TRIIVCO group
else if (TRI_URL.includes(domain)) {
	tenant = TENANTS.TRIV;
}
// FAVORITE group
else if (FAV_URL.includes(domain)) {
	tenant = TENANTS.FAV;
}
// Empower group
else if (EMP_URL.includes(domain)) {
	tenant = TENANTS.EMP;
}
// PH group
else if (PH_URL.includes(domain)) {
	tenant = TENANTS.PH;
}

export const TENANT = tenant;
export const API_URL = {
	GETWAY_API: (tenant === TENANTS.PH) ? process.env.REACT_APP_GETWAY_API_PH : process.env.REACT_APP_GETWAY_API,
	COMMON_GATEWAY_API: (tenant === TENANTS.PH) ? process.env.REACT_APP_COMMON_GATEWAY_API_PH : process.env.REACT_APP_COMMON_GATEWAY_API,
	API_KEY: process.env.REACT_APP_API_KEY || "sfanode-ac1faa7b-9fe9-4483-9525-5cc4ce94c639",
};
export const SETTING = {
	CRYPTO_KEY: "U*oDwrIU!B#QX37%#24",
	RESEND_OTP_TIME_IN_SECOND: 30,
};
export const NAME_VALIDATION = /^[A-Za-z\s]+$/;

export const ALPHA_NUMERIC_VALIDATION = /^[a-zA-Z0-9 ]+$/;

export const ACCOUNT_NO_VALIDATION = /^\d{10,16}$/;

export const SPOUSE_OFFICE_ADDRESS_VALIDATION = /^[a-zA-Z0-9@%_&*$#!~()<>?+:,;=^?|'-<>.{} ]{1,70}$/;

export const SPOUSE_BUSINESS_VALIDATION = /^[a-zA-Z0-9@%_&*$#!~()<>?+:,;=^?|'-<>.{} ]{1,20}$/;

export const EMERGENCY_CONTACT_NAME_VALIDATION = /^[a-zA-Z0-9@%_&*$#!~()<>?+:,;=^?|'-<>.{} ]{1,50}$/;

export const EMERGENCY_CONTACT_ADDRESS_VALIDATION = /^[a-zA-Z0-9@%_&*$#!~()<>?+:,;=^?|'-<>.{} ]{1,70}$/;

export const MOBILE_VLIDATION_RULE = /^\+\d{1,3}-\d{9,10}$/;

export const PASSWORD_VALIDATION = /^(?=.*\d)(?=.*[a-z])(?=.*[!@#$%^&*])(?=.*[A-Z])[0-9a-zA-Z!@#$%^&*]{8,}$/;
// eslint-disable-next-line no-useless-escape
export const EMAIL_VALIDATION = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
// eslint-disable-next-line no-useless-escape
export const EMAIL_VALIDATION_ADMIN = (TENANT === TENANTS.PH) ? /^([A-Za-z0-9_\-\.]+)@(carmudi|girnarsoft|cardekho|finsso)\.([A-Za-z]{2,4}|id|com|com\.ph|co\.in)$/ : (TENANT === TENANTS.FAV) ? /^([A-Za-z0-9_\-\.]+)@(girnarsoft\.co\.in|girnarsoft\.com|favorite\.id|cardekho\.com|triivco\.com|otosupport\.com)$/ : /^([A-Za-z0-9_\-\.]+)@(oto|otosupport|girnarsoft|cardekho|triivco|favorite)\.([A-Za-z]{2,4}|id|com|co\.in)$/;
export const MARGIN_FOR_OTO_MAX_VALIDATION = 1000000;

export const IS_USER_ACCESS_PAGE = (controller, action) => {
	let isUserHasRights = false, isEditAccess = false;
	const userAccessFeatures = secureStorage.getItem("userAccess");
	if (userAccessFeatures && userAccessFeatures.length) {
		let isKeyExist = _.findKey(userAccessFeatures, function (v) {
			if (controller && v.controller && action && v.action) {
				return (
					v.controller.toLowerCase() === controller.toLowerCase() &&
					v.action.toLowerCase() === action.toLowerCase()
				);
			}
		});
		isUserHasRights = isKeyExist ? true : false;
		isEditAccess = isKeyExist ? ((Number(userAccessFeatures[isKeyExist].access_type) === 1) ? true : false) : false
	}

	return {
		is_access_page: isUserHasRights,
		is_edit_access: isEditAccess
	};
};

export const APIV = 2;

export const FINANCIER_PRODUCT_TYPE_OPTIONS = [
	{ label: "UCF", value: "UCF" },
	{ label: "UCRF", value: "UCRF" },
	{ label: "UBRF", value: "UBRF" },
	{ label: "INSURANCE", value: "INSURANCE" },
];
export const TAGGING_ROLES = (TENANT === TENANTS.OTO || TENANT === TENANTS.TRIV) ? [53, 54, 57] : [53, 57, 52, 56];

export const Zone = (TENANT === TENANTS.PH) ? [
	{ id: 1, value: 'Philippines  Zone', label: 'Philippines Zone' }
] : [
	{ id: 5, value: 'Indonesia  Zone', label: 'Indonesia  Zone' }
];

export const Business = (TENANT === TENANTS.TRIV) ? [
	{ id: 1, value: 'TriiVCO', label: 'TriiVCO' }
] : (TENANT === TENANTS.FAV) ? [
	{ id: 1, value: 'Favorite', label: 'Favorite' },
	{ id: 2, value: 'Pinjam Bagus', label: 'Pinjam Bagus' },
	{ id: 3, value: 'PRIMA', label: 'PRIMA' }
] : (TENANT === TENANTS.EMP) ? [
	{ id: 1, value: 'Empower', label: 'Empower' }
] : (TENANT === TENANTS.PH) ? [
	{ id: 1, value: 'Carmudi', label: 'Carmudi' }
] : [
	{ id: 1, value: 'OTO', label: 'OTO' }
]

export const Vertical = (TENANT === TENANTS.PH) ? [
	{ id: 1, value: 'Used Car', label: 'Used Car', business_unit_ids: [1] },
	{ id: 2, value: 'Insurance', label: 'Insurance', business_unit_ids: [1] },
	{ id: 3, value: 'Title Transfer', label: 'Title Transfer', business_unit_ids: [1] },
	{ id: 4, value: 'REM', label: 'REM', business_unit_ids: [1] }	 
] : (TENANT === TENANTS.FAV) ? [
	{ id: 1, value: 'Used Car', label: 'Used Car', business_unit_ids: [1, 2, 3] },
	{ id: 2, value: 'HRF', label: 'HRF', business_unit_ids: [1] },
] : (TENANT === TENANTS.OTO) ? [
	{ id: 1, value: 'Used Car', label: 'Used Car', business_unit_ids: [1] },
	{ id: 2, value: 'HRF', label: 'HRF', business_unit_ids: [1] },
] : [
	{ id: 1, value: 'Used Car', label: 'Used Car', business_unit_ids: [1] },
]

export const defaultBusiness = 1
export const defaultVertical = 1

export const defaultZone = (TENANT === TENANTS.PH) ? 1 : 5

export const VIRTUAL_ADMIN = "Virtual Admin"

export const EmploymentType = [
	{ value: '0', label: 'Off Roll' },
	{ value: '1', label: 'On Roll' },
];

export const BusinessLine = (TENANT === TENANTS.PH) ? [
	{ value: 'UCF', label: 'Used Car Finance' },
	{ value: 'UCRF', label: 'Used Car Refinance' },
	{ value: 'UBRF', label: 'Used Bike Refinance' },
	{ value: 'insurance', label: 'Insurance' },
	{ value: 'Classifieds', label: 'Classifieds' },
	{ value: 'UCTT', label: 'New Initiatives' },
	{ value: 'CF', label: 'Consumer Financing' },
	{ value: 'inventory_funding', label: 'Inventory Funding' }
] : [
	{ value: 'UCF', label: 'Used Car Finance' },
	{ value: 'UCRF', label: 'Used Car Refinance' },
	{ value: 'UBRF', label: 'Used Bike Refinance' },
	{ value: 'insurance', label: 'Insurance' }
];

export const validationForFields = {
	"incentive_percentage": [52],
	"current_occupation": [53],
	"referral_name": [53],
	"company_name": [53, 54, 57],
	"company_address": [54, 57],
	"designation": [53],
	"tagging": (TENANT === TENANTS.OTO || TENANT === TENANTS.TRIV) ? [53, 54, 57] : (TENANT === TENANTS.FAV) ? [53, 57, 52, 56] : [53, 57],
	"source": [53, 54, 57],
	"is_tax_booster_enable": [56],
	"rt": [54, 57],
	"rw": [54, 57],
	"bm_grading": [52],
	"agent_wallet_view": (TENANT === TENANTS.OTO) ? [53, 54, 57, 52, 46] : (TENANT === TENANTS.FAV) ? [53, 46, 57] : [],
	"whatsapp_mobile_number": [53],
	"secondary_reporting_div_business_line": [],//['UCRF'],
	"secondary_reporting_div": [],//[53, 54, 57]
	"alternative_number": [53]
}
export const invalidNumberValues = ["-", "+", "e", "."];

export const imageWidth = 360;
export const minDateYear = 1970;
export const minDOBDateYear = '1946-01-01';
export const Role = (TENANT === TENANTS.OTO) ? {
	"RBH": 51,
	"BM": 52,
	"Agent": 53,
	"BRO": 54,
	"Virtual Admin": 55,
	"AM": 56,
	"ARO TEST": 57,
	"ARO": 57,
	"ZM": 58,
	"DZM": 61,
	"ARCO": 59,
	"VP": 50,
	"Alpha Agent": 46,
} : (TENANT === TENANTS.FAV) ? {
	"RBH": 51,
	"MM": 52,
	"FA": 53,
	"MO": 57,
	"Virtual Admin": 55,
	"ARM": 56,
	"RM": 58,
	"VP": 50,
	"Platinum Agent": 46,
	"AM": 60
} : (TENANT === TENANTS.TRIV) ? {
	"RBH": 51,
	"BM": 52,
	"TOS": 53,
	"Virtual Admin": 55,
	"AM": 56,
	"ZM": 58,
	"VP": 50,
} : (TENANT === TENANTS.PH) ? {
	"Virtual Admin": 1,
	"President": 2,
	"Sales Head": 3,
	"Territory Head": 4,
	"Sales Manager": 5,
	"Sales Officer": 6,
	"ARO": 7,
	"Agent": 8
} : {
	"RBH": 51,
	"BM": 52,
	"Agent": 53,
	"Virtual Admin": 55,
	"AM": 56,
	"KAO": 57,
	"RM": 58,
	"ARCO": 59,
	"VP": 50,
	"Alpha Agent": 46,
};

export const RoleId = (TENANT === TENANTS.OTO) ? {
	"51": "RBH",
	"52": "BM",
	"53": "Agent",
	"54": "BRO",
	"55": "Virtual Admin",
	"56": "AM",
	"57": "ARO",
	"58": "ZM",
	"61": "DZM",
	"59": "ARCO",
	"50": "VP",
	"46": "Alpha Agent"
} : (TENANT === TENANTS.FAV) ? {
	"51": "RBH",
	"52": "MM",
	"53": "FA",
	"57": "MO",
	"55": "Virtual Admin",
	"56": "ARM",
	"58": "RM",
	"50": "VP",
	"46": "Platinum Agent",
	"60": "AM"
} : (TENANT === TENANTS.TRIV) ? {
	"51": "RBH",
	"52": "BM",
	"53": "TOS",
	"55": "Virtual Admin",
	"56": "AM",
	"58": "ZM",
	"50": "VP",
} : (TENANT === TENANTS.PH) ? {
	"1": "Virtual Admin",
	"2": "President",
	"3": "Sales Head",
	"4": "Territory Head",
	"5": "Sales Manager",
	"6": "Sales Officer",
	"7": "ARO"
} : {
	"51": "RBH",
	"52": "BM",
	"53": "Agent",
	"54": "BRO",
	"55": "Virtual Admin",
	"56": "AM",
	"57": "KAO",
	"58": "RM",
	"59": "ARCO",
	"50": "VP",
	"46": "Alpha Agent"
}

export const BasicDetailConfig = {
	"source": [
		{
			"value": "Website",
			"label": "Website"
		},
		{
			"value": "BM",
			"label": "BM"
		},
		{
			"value": "referral_agent",
			"label": "Referral Agent"
		},
		{
			"value": "Others",
			"label": "Others"
		}
	],
	"source_agent": [
		{
			"value": "Website",
			"label": "Website"
		},
		{
			"value": "BM",
			"label": "BM"
		},
		{
			"value": "referral_agent",
			"label": "Referral Agent"
		},
		{
			"value": "mass_hiring",
			"label": "Mass Hiring"
		},
		{
			"value": "join_us",
			"label": "Join Us"
		},
		{
			"value": "user_agent_enquiry",
			"label": "User Agent Enquiry"
		},
		{
			"value": "competitor",
			"label": "Competitor"
		},
		{
			"value": "oto_agent",
			"label": "Oto Agent"
		},
		{
			"value": "rampwin",
			"label": "Rampwin"
		},
		{
			"value": "Others",
			"label": "Others"
		}
	],
	"document": [
		{
			"doc_id": "1",
			"doc_title": "Selfie with KTP",
			"doc_min": "1",
			"doc_max": "1",
			"doc_required": "1",
			"doc_logo_url": "https://otobackendbeta.storage.googleapis.com/SFA/12/1648618247543.png",
			"doc_bg_color": "#BFF8FC"
		},
		{
			"doc_id": "2",
			"doc_title": "KTP",
			"doc_min": "1",
			"doc_max": "1",
			"doc_required": "1",
			"doc_logo_url": "https://otobackendbeta.storage.googleapis.com/SFA/12/1648618247544.png",
			"doc_bg_color": "#FFF1D6"
		},
		{
			"doc_id": "3",
			"doc_title": "Bank Statement",
			"doc_min": "1",
			"doc_max": "1",
			"doc_required": "1",
			"doc_logo_url": "https://otobackendbeta.storage.googleapis.com/SFA/12/1648618247545.png",
			"doc_bg_color": "#D8EAFF"
		},
		{
			"doc_id": "4",
			"doc_title": "NPWP",
			"doc_min": "1",
			"doc_max": "1",
			"doc_required": "1",
			"doc_logo_url": "https://otobackendbeta.storage.googleapis.com/SFA/12/1648618247545.png",
			"doc_bg_color": "#C5F8EB"
		}
	],
	"tagging_roles": {
		"Agent": [
			{
				"value": "regular",
				"label": "Regular"
			},
			{
				"value": "dsoo",
				"label": "DSOO"
			},
			{
				"value": "dse",
				"label": "DSE"
			}
		],
		"ARO": [
			{
				"value": "sr_aro",
				"label": "Sr. ARO"
			},
			{
				"value": "aro",
				"label": "ARO"
			},
			{
				"value": "jr_aro",
				"label": "Jr. ARO"
			}
		],
		"BRO": [
			{
				"value": "sr_bro",
				"label": "Sr. BRO"
			},
			{
				"value": "bro",
				"label": "BRO"
			},
			{
				"value": "jr_bro",
				"label": "Jr. BRO"
			}
		]
	},
	"business_line": (TENANT === TENANTS.PH) ? [
		{ "value": "UCF", "label": "Used Car Finance" },
		{ "value": "UCRF", "label": "Used Car Refinance" },
		{ "value": "UBRF", "label": "Used Bike Refinance" },
		{ "value": "insurance", "label": "Insurance" },
		{ "value": "Classifieds", "label": "Classifieds" },
		{ "value": "UCTT", "label": "New Initiatives" },
		{ "value": "CF", "label": "Consumer Financing" },
		{ "value": "inventory_funding", "label": "Inventory Funding" }
	] : [
		{ "value": "UCF", "label": "Used Car Finance" },
		{ "value": "UCRF", "label": "Used Car Refinance" },
		{ "value": "UBRF", "label": "Used Bike Refinance" },
		{ "value": "insurance", "label": "Insurance" }
	],
	"hiring_source": [
		{
			"value": "existing",
			"label": "Existing"
		},
		{
			"value": "new",
			"label": "New"
		}
	]
}


export const VP_ID = 50

export const PAGINATION = {
	PAGE_SIZE: 50
}

// export const MANAGER_ROLES = [
// 	{ "name": "ARO", "id": 57, "rank": 8 },
// 	{ "name": "ARCO", "id": 59, "rank": 7 },
// 	{ "name": "BM", "id": 52, "rank": 6 },
// 	{ "name": "AM", "id": 56, "rank": 5 },
// 	{ "name": "ZM", "id": 58, "rank": 4 },
// 	{ "name": "RBH", "id": 51, "rank": 3 },
// 	{ "name": "VP", "id": 50, "rank": 2 },
// 	{ "name": "Virtual Admin", "id": 55, "rank": 1 },
// ]
export const SFA_URL = process.env.REACT_APP_SFA_URL || "https://sfa.oto.com/";
export const EXECUTIVE_ROLES = TENANT === TENANTS.PH ? [3] : [53, 54];
export const SFA_NEW_URL = process.env.REACT_APP_SFA_NEW_URL || "https://sfa.oto.com/";
export const ESIGN_BASE_URL = SFA_NEW_URL + "user/esign_agreement_log_view";
export const SFA_LOGIN_URL = SFA_NEW_URL + "login";
export const FINANCIER_API_KEY = "d77bc90f-6824-47da-94c2-2930de73daad"
export const VISIT_EXECUTIVE_ROLES = TENANT === TENANTS.PH ? [4, 5, 6] : [52, 54, 57, 56, 51, 58, 61];
export const STATUS = [
	{ id: 1, label: 'Active', value: 'active' },
	{ id: 2, label: 'Inactive', value: 'inactive' },
]
export const FORMAT_BULK_UPLOAD = [
	{
		"SFA ID": "1",
		"ASLI RI Mobile Number 1": "8888888888",
		"ASLI RI Mobile Number 2": "8888888888",
		"ASLI RI Mobile Number 3": "8888888888",
		"ASLI RI Mobile Number 4": "8888888888",
		"ASLI RI Mobile Number 5": "8888888888"
	}
]
export const PROGRESSION_FILTER_ROLES = [56, 58, 51]
export const ROLE_ABOVE_BM = [50, 51, 56, 58, 61]
export const ACCOUNT_MANAGER_BUSINESS_LINE = "UCF"

export const ADMIN_ROLES = {
	super_admin: 1,
	master_admin: 2,
	admin: 3,
	viewer: 4,
	sales_support: 5,
	onboarding_specialist: 6
};

export const ADMIN_ROLE_ID = {
	1: 'super_admin',
	2: 'master_admin',
	3: 'admin',
	4: 'viewer',
	5: 'sales_support',
	6: 'onboarding_specialist',
};

export const REJECT_STATUS = '3'
export const INACTIVE_STATUS = '0'
export const MONTH_NAMES = [
	{ id: 1, label: 'January' },
	{ id: 2, label: 'February' },
	{ id: 3, label: 'March' },
	{ id: 4, label: 'April' },
	{ id: 5, label: 'May' },
	{ id: 6, label: 'June' },
	{ id: 7, label: 'July' },
	{ id: 8, label: 'August' },
	{ id: 9, label: 'September' },
	{ id: 10, label: 'October' },
	{ id: 11, label: 'November' },
	{ id: 12, label: 'December' }
];
export const TARGET_TYPE = [
	{ id: 1, label: 'Market Place' },
	{ id: 2, label: 'DIF' }
];
export const TARGET_UPLOAD_SAMPLE = [
	{
		"SFA ID": "1",
		"Overall Target": "13",
		"NIM Target": "9",
		"Month": "April",
	}
]

export const IF_TARGET_UPLOAD_SAMPLE = [
	{
		"SFA ID": "1",
		"Month": "April",
		"Overall Target": "13",
	}
]

export const ECA_AGENT_TAGGING = ['eca', 'eca_l1']
export const REDIRECT_URL = window.location.origin + "/login"
export const MOBILE_VALIDATION = /^8[0-9]{7,11}$/;
export const TRI_TARGET_UPLOAD_SAMPLE = [
	{
		"SFA ID": "1",
		"Target": "13",
		"Month": "April",
	}
]
export const IS_REQEST_RESPONSE_ENCRYPT = 1;
export const IGNORE_END_POINT_ENCRYPTION = ['upload_target_list', 'bulkUploadUserData', 'tri_upload_target_list', 'login-by-email', 'upload_fid_users','refresh_token', 'notification_bulk_upload']
export const OTHER_REASON_FOR_REJECTION_ID = 5;
export const LAP_BUSINESS_LINE_ID = "LAP";
export const VIRTUAL_ADMIN_ROLE_ID = 1;
export const TERRITORY_ROLE_ID = 4;
export const TERRITORY_DPD_BUSINESSLINE = ["UCF", "UCRF", "UBRF"];
export const PINJAM_BAGUS_BUSINESSLINE = ["UCRF"];
export const PRIMA_BUSINESSLINE = ["UCRF"];
export const PINJAM_BAGUS_BUSINESS_UNIT_ID = 2;
export const PRIMA_BUSINESS_UNIT_ID = 3;
export const FID_TAGGING_BULK_UPLOAD_FORMAT = [{ "SFA ID": "1", "Category ID": "1" }]
export const DEBOUNCE_DELAY_IN_MS = 900;

export const GENDER = [
	{ label: 'Male', value: 1 },
	{ label: 'Female', value: 2 }
];
export const BLOOD_TYPE = [
	{ label: 'O', value: 1 },
	{ label: 'A', value: 2 },
	{ label: 'AB', value: 3 },
	{ label: 'B', value: 4 }
];
export const MARITAL_STATUS = [
	{ label: 'Belum Kawin', value: 1 },
	{ label: 'Kawin', value: 2 },
	{ label: 'Cerai Hidup', value: 3 },
	{ label: 'Cerai Mati', value: 4 }
];
export const CBI_DOCUMENT_ACCEPTED_FORMATS = ["application/pdf"];
export const HRF_DOCUMENT_ACCEPTED_FORMATS = ["application/pdf", "image/jpeg", "image/jpg", "image/png"];
export const HRF_BUSINESS_VERTICAL_ID = 2;
export const REM_VERTICAL_ID = 4;
export const REM_BUSINESS_LINE_ID = "REM";
export const FAVORITE_BUSINESS_UNIT_ID = 1;
export const BUSINESS_LINE_IDS = {
    UCF: "UCF",
    UCRF: "UCRF",
    UBRF: "UBRF",
    LAP: "LAP",
    insurance: "insurance",
    classifieds: "classifieds",
    bursa: "bursa",
    IF: "inventory_funding",
    HRF: "HRF",
    CF: "CF",
    Classifieds: "Classifieds",
    UCTT: "UCTT",
}

export const isPhSalesOfficer = (roleId) =>
    TENANT === TENANTS.PH && parseInt(roleId) === Role['Sales Officer'];

export const showPhSalesOfficerTaggingField = (roleId, taggingRoles = [], businessVerticalId) =>
    isPhSalesOfficer(roleId) && (taggingRoles || []).length > 0 && businessVerticalId !== REM_VERTICAL_ID;

export const showPhSalesOfficerTaggingDisplay = (roleId, taggingId) =>
    isPhSalesOfficer(roleId) && !!taggingId;

/** @deprecated use showPhSalesOfficerTaggingField / showPhSalesOfficerTaggingDisplay */
export const isIfSalesOfficerTaggingRequired = (roleId, businessLine) =>
    isPhSalesOfficer(roleId) && businessLine === BUSINESS_LINE_IDS.IF;

export const getTaggingLabel = (taggingId, configTaggingRoles = []) => {
    const match = (configTaggingRoles || []).find((item) => item.value === taggingId);
    return match ? match.label : taggingId || '-';
};
export const TAGGING_IDS = {
	PROPERTY_BROKER: "property_broker",
	RETAIL_AGENT: "retail_agent",
}

export const BULK_USERS_UPLOAD_FORMAT = [
  {
    "ROLE": "",
    "Business Line": "",
    "Primary Reporting Role": "",
    "Primary Reporting Manager": "",
    "Username": "",
    "Mobile": "",
    "Email": "",
    "KTP ID": "",
    "Employment Type": "",
    "Joining Date": "",
    "Bank Name": "",
    "Branch Name": "",
    "Account Number": "",
    "Beneficiary Name": "",
    "NPWP": "",
    "State": "",
    "City": "",
    "Tagging": "",
    "Source": "",
    "Postal Code": "",
    "RT": "",
    "RW": "",
    "Employee ID": "",
    "Tagging ID": "",
    "Business Unit ID": "",
    "Business Vertical ID": ""
  }
];

export const BULK_USERS_UPLOAD_FORMAT_TRIV = [
  {
    "ROLE": "",
    "Business Line": "",
    "SFA ID": "",
    "Primary Reporting Role": "",
    "Primary Reporting Manager": "",
    "Username": "",
    "Mobile": "",
    "Email": "",
    "KTP ID": "",
    "Employment Type": "",
    "Joining Date": "",
    "Bank Name": "",
    "Branch Name": "",
    "Account Number": "",
    "Beneficiary Name": "",
    "NPWP": "",
    "State": "",
    "City": "",
    "Tagging": "",
    "Source": "",
    "Postal Code": "",
    "RT": "",
    "RW": "",
    "Employee ID": "",
    "Tagging ID": "",
    "DOB": "",
    "Address": ""
  }
];

export const USER_MOBILE_INFO_LOG_TYPE = {
    MOBILE: 'mobile',
    USERS: 'users'
}
export const TOP_HIERARCHY_ROLE_ID = TENANT === TENANTS.PH ? Role['President'] : Role['VP'];
